export class DocumentLayoutPolicy {
    'manage:own-company' (user, verbObject, verb, company) {
        return user.aclPermissions.includes('DocumentLayout:manage:own-company') && company.id === user.consultant.consultingCompany.id
    }
}
